'use strict';

// this directive takes the attribute value of close-panel as the selector to close
module.exports = /*@ngInject*/
function() {
    return {
        scope: {
            panelSelector: '@closePanel'
        },
        link: function(scope, element, attrs) {
            element.bind('click', function(e) {
                jQuery('.' + scope.panelSelector).slideUp();
                e.preventDefault();
            });
        }
    };
};
